import { useEffect, useMemo, useState } from 'react';
import { fetchAllLanguages, getStaticLanguages } from 'api/worldLanguages';

/**
 * World languages for destination multi-select.
 * Starts with the static ISO list (instant, no DB), then refreshes once from
 * REST Countries into an in-memory 24h cache — same idea as countries/cities.
 */
export const useLanguages = () => {
    const [languages, setLanguages] = useState(() => getStaticLanguages());
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;

        (async () => {
            try {
                const list = await fetchAllLanguages();
                if (!cancelled && Array.isArray(list) && list.length > 0) {
                    setLanguages(list);
                }
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        })();

        return () => {
            cancelled = true;
        };
    }, []);

    const languageOptions = useMemo(
        () => languages.map((name) => ({ value: name, label: name })),
        [languages]
    );

    return {
        languages,
        languageOptions,
        isLoading,
    };
};
